import { ReactNode, useContext } from 'react';
import { Grid } from '@mui/material';
import CustomSnackbar from '../components/UI/CustomSnackbar';
import EnvironmentBadge from '../components/UI/EnvironmentBadge';
import { PresentationChromeContext } from '../store/presentation-chrome-context';

const PanelLayout = ({ children }: { children: ReactNode }) => {
	const { hideDevChrome } = useContext(PresentationChromeContext);

	return (
		<>
			{!hideDevChrome && <EnvironmentBadge />}
			<Grid
				item
				container
				component={'main'}
				sx={{
					width: '100vw',
					height: '100vh',
				}}
			>
				{children}
			</Grid>
			<CustomSnackbar />
		</>
	);
};

export default PanelLayout;
